import * as React from 'react';
export const IcCompoundInterest = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 19H5v-1.91h1.18c7 0 10.16-4.08 12.68-9.39l.19.58A1 1 0 0020 9c.106.014.214.014.32 0A1 1 0 0021 7.68l-1-3a1 1 0 00-1.27-.63l-3 1A1.019 1.019 0 1016.32 7l.84-.28C14.68 12 11.86 15.53 5 15.07V4a1 1 0 00-2 0v16a1 1 0 001 1h16a1 1 0 000-2z'
      fill='currentColor'
    />
  </svg>
);
